const DOMAIN_API_KEY_MAPPING = {
  'artist.stickies.co.il': 'art',
  'artist-dev.stickies.co.il': 'art',
};

const DEFAULT_API_KEY = 'stickies-124';

export { DOMAIN_API_KEY_MAPPING, DEFAULT_API_KEY };
